<template>
  <div class="security-wrapper">
    <Title
      title="智慧交流"
      subTitle="Intelligent Security"
      width="450px"
    ></Title>
    <div class="content">
      <div class="left">
        <div class="tit">
          活动举办<span>{{ pagedata.activityCount }}</span
          >次
        </div>
        <div id="chart1"></div>
        <div class="tit">
          远程交流<span>{{ pagedata.bizChatCount }}</span
          >次
        </div>
        <div class="tit">
          远程交流时长<span>{{ (pagedata.sumMin / 60).toFixed() }}</span
          >小时
        </div>
        <div class="scroldiv">
          <div class="tit" style="margin-bottom: 15px">积分排行榜</div>
          <dv-scroll-board
            :config="record_config1"
            style="width: 100%; height: 300px"
          />
        </div>
      </div>
      <div class="right">
        <div class="tit">
          老年大学课堂<span>{{ pagedata.elderClassCount }}</span
          >次
        </div>
        <div id="chart2"></div>
        <div class="tit">
          志愿老年人<span>{{ pagedata.elderVolCount }}</span
          >人
        </div>
        <div class="tit">
          本周积分下发<span>{{
            pagedata.pointByWeek ? pagedata.pointByWeek : 0
          }}</span
          >分
        </div>
        <div class="scroldiv">
          <div class="tit" style="margin-bottom: 15px">本周志愿之星</div>
          <dv-scroll-board
            :config="record_config2"
            style="width: 100%; height: 300px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Commen/CloseTitle";
const echarts = require("echarts");
import { chartone, charttwo } from "./charts/chart1";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Title,
  },
  data() {
    return {
      branchId: 6627,
      yearMonthStart: "2022-04-01",
      yearMonthEnd: "2022-04-30",
      callInfoDate: "",
      pagedata: {},

      record_config1: {
        // header: ["时间", "巡防点", "巡防人员", "情况说明"],
        rowNum: 10,
        // columnWidth: ['33%', '33%', '33%', '33%'],
        headerBGC: "rgba(0,0,0,0)",
        oddRowBGC: "rgba(103, 118, 137, 0.3)",
        evenRowBGC: "rgba(0,0,0,0)",
        data: [],
      },
      record_config2: {
        // header: ["时间", "巡防点", "巡防人员", "情况说明"],
        rowNum: 10,
        // columnWidth: ['33%', '33%', '33%', '33%'],
        headerBGC: "rgba(0,0,0,0)",
        oddRowBGC: "rgba(103, 118, 137, 0.3)",
        evenRowBGC: "rgba(0,0,0,0)",
        data: [],
      },
    };
  },
  computed: {
    // ...mapState(["communicationData"]),
  },
  created() {
    this.pagedata = this.$store.state.communicationData.data.data;
  },
  mounted() {
    // this.drawChart();
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    // ...mapActions(["getCommunicationData"]),
    async getData() {
      // let json = {
      //   callInfoDate: this.getTime(),
      //   yearMonthStart: this.yearMonthStart,
      //   yearMonthEnd: this.yearMonthEnd,
      //   branchId: this.branchId,
      // };
      // await this.getCommunicationData(json);
      // this.pagedata = this.communicationData.data.data;
      // 活动趋势
      // this.pagedata.actList
      let data1 = {
        xdata: [],
        ydata1: [],
        ydata2: [],
      };
      this.pagedata.actList.forEach((item, index) => {
        if (item.activityType == 1) {
          item.rows.forEach((item1, index) => {
            data1.xdata.push(item1.month);
            data1.ydata1.push(item1.number);
          });
        } else {
          item.rows.forEach((item1, index) => {
            data1.ydata2.push(item1.number);
          });
        }
      });
      // 课堂趋势
      let data2 = {
        xdata: [],
        ydata1: [],
        ydata2: [],
        ydata3: [],
      };
      this.pagedata.calList.forEach((item, index) => {
        if (item.curriculumType == 1) {
          item.rows.forEach((item, index) => {
            data2.xdata.push(item.month);
            data2.ydata1.push(item.number);
          });
        } else if (item.curriculumType == 2) {
          item.rows.forEach((item, index) => {
            data2.ydata2.push(item.number);
          });
        } else {
          item.rows.forEach((item, index) => {
            data2.ydata3.push(item.number);
          });
        }
      });

      this.drawChart(data1, data2);
      // 积分排行榜
      this.pagedata.pointRankByTotal.forEach((item, index) => {
        let data = [index + 1, item.name, item.points];
        this.record_config1.data.push(data);
      });
      this.record_config1 = { ...this.record_config1 };
      // 周积分排行榜
      // pointRankByWeek
      this.pagedata.pointRankByWeek.forEach((item, index) => {
        let data = [index + 1, item.name, item.points];
        this.record_config2.data.push(data);
      });
      this.record_config2 = { ...this.record_config2 };
    },

    drawChart(data1, data2) {
      let activechart = echarts.init(document.getElementById("chart1"));
      let oldchart = echarts.init(document.getElementById("chart2"));
      activechart.setOption(chartone(data1));
      oldchart.setOption(charttwo(data2));
    },
    getTime() {
      let date_ = new Date();
      let seperator1 = "-";
      let year = date_.getFullYear();
      let month = date_.getMonth() + 1;
      let strDate = date_.getDate();
      return year + seperator1 + month + seperator1 + strDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
  width: 450px;
  // width: calc(100% - 20px);
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  color: #fff;
  font-size: 14px;
  .tit {
    margin-top: 5px;
    // line-height: 30px;
    span {
      color: #d1f237;
    }
  }
  .left {
    width: 50%;
    #chart1 {
      width: 100%;
      height: 220px;
    }
  }
  .right {
    width: 50%;
    #chart2 {
      width: 100%;
      height: 220px;
    }
  }
}
</style>
